<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb :crumb="name"></breadcrumb>
          <div class="intro-wrapper main-x-spacing pb-2">
            <h2>{{ title }}</h2>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col cols="12" class="body-middle-col pt-0">
                <div class="sectionTabs horizontalTab">
                  <v-tabs
                    v-model="currentTab"
                    class="tabBorderBottom"
                    hide-slider
                  >
                    <v-tab href="#tab-1" class="section-tab-header py-6">
                      General Settings
                    </v-tab>
                    <v-tab href="#tab-2" class="section-tab-header py-6">
                      Menu
                    </v-tab>

                    <!-- <v-tab class="section-tab-header py-6"> Staff </v-tab> -->
                    <v-tab href="#tab-3" class="section-tab-header py-6">
                      Tax Rates
                    </v-tab>
                    <v-tab href="#tab-4" class="section-tab-header py-6">
                      Surcharges
                    </v-tab>

                    <v-tab-item id="tab-1">
                      <v-row>
                        <v-col cols="12">
                          <v-form ref="updateLocationForm">
                            <v-row>
                              <v-col cols="12" lg="8" md="8" sm="12">
                                <div class="form-group d-flex align-center">
                                  <span class="label-spacing"> Name: </span>
                                  <v-text-field
                                    v-model="locationName"
                                    dense
                                    hide-details
                                    :rules="[rules.required]"
                                    outlined
                                  ></v-text-field>
                                </div>
                                <div class="form-group d-flex align-center">
                                  <span class="label-spacing"> Address: </span>
                                  <v-text-field
                                    v-model="addressLineOne"
                                    dense
                                    hide-details
                                    :rules="[rules.required]"
                                    outlined
                                  ></v-text-field>
                                </div>
                                <div class="form-group d-flex align-center">
                                  <span class="label-spacing">
                                    Address 2:
                                  </span>
                                  <v-text-field
                                    v-model="addressLineTwo"
                                    dense
                                    hide-details
                                    :rules="[rules.required]"
                                    outlined
                                  ></v-text-field>
                                </div>
                                <div class="form-group d-flex align-center">
                                  <span class="label-spacing"> City: </span>
                                  <v-text-field
                                    v-model="city"
                                    dense
                                    hide-details
                                    :rules="[rules.required]"
                                    outlined
                                  ></v-text-field>
                                </div>
                                <div class="form-group d-flex align-start">
                                  <span class="label-spacing"> TimeZone: </span>
                                  <div class="all-tags">
                                    <v-select
                                      v-model="timeZone"
                                      :items="getTimeZone"
                                      hide-details
                                      flat
                                      solo
                                    ></v-select>
                                  </div>
                                </div>

                                <div class="form-group d-flex align-center">
                                  <span class="label-spacing"> Currency: </span>
                                  <v-select
                                    outlined
                                    v-model="currency"
                                    :rules="[rules.required]"
                                    :items="allEntCurrencies"
                                    item-text="name"
                                    item-value="id"
                                    :menu-props="{ offsetY: true }"
                                    dense
                                    placeholder="Currency"
                                    class="v-text-field"
                                    required
                                  ></v-select>
                                </div>
                                <div class="form-group d-flex align-center">
                                  <span class="label-spacing">
                                    Telephone Number:
                                  </span>
                                  <v-text-field
                                    v-model="telephoneNumber"
                                    dense
                                    hide-details
                                    :rules="[rules.required, rules.numberMax15]"
                                    outlined
                                  ></v-text-field>
                                </div>

                                <div class="form-group d-flex align-center">
                                  <span class="label-spacing"> </span>
                                  <v-btn
                                    :ripple="false"
                                    depressed
                                    width="17%"
                                    :loading="saveLoader"
                                    large
                                    class="success gen-button white--text mt-2"
                                    @click="updateLocation"
                                  >
                                    <span>Save</span>
                                  </v-btn>
                                </div>
                              </v-col>
                              <v-col cols="12" lg="4" md="4" sm="12">
                                <div class="form-group d-flex">
                                  <div class="">
                                    <div>Location Image:</div>
                                    <div
                                      v-if="isSelected == false"
                                      class="uploadHolder uploadPreview mb-2"
                                    ></div>
                                    <div v-if="isSelected == true">
                                      <v-img
                                        contain
                                        class="uploadSrc"
                                        max-height="300"
                                        max-width="300"
                                        :src="url"
                                      ></v-img>
                                    </div>

                                    <div>
                                      <div class="">
                                        <div class="uploadButtonWrapper v-btn">
                                          <v-file-input
                                            v-model="image"
                                            @change="previewImage"
                                            @click:clear="clearSelected"
                                            color="black"
                                            hide-details
                                            placeholder="Upload File"
                                            class="text-capitalize uploadButton"
                                            flat
                                            solo
                                            prepend-icon="undefined"
                                            prepend-inner-icon="publish"
                                            :rules="[rules.required]"
                                          >
                                            <template
                                              v-slot:selection="{ text }"
                                            >
                                              <v-chip
                                                small
                                                label
                                                color="primary"
                                              >
                                                {{ text }}
                                              </v-chip>
                                            </template>
                                          </v-file-input>
                                        </div>

                                        <span class="ml-4">No File Chosen</span>
                                      </div>
                                      <p class="caption">
                                        Accepts JPG and PNG files only.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-col>
                      </v-row>
                    </v-tab-item>

                    <v-tab-item id="tab-2">
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <div class="table-menu mt-0">
                            <v-row justify="space-between" class="rowNoHeight">
                              <v-col cols="2">
                                <h2>All Categories</h2>
                              </v-col>
                              <v-col cols="8">
                                <v-text-field
                                  v-model="searchQuery"
                                  prepend-inner-icon="search"
                                  label="Search Menu Item"
                                  class="toWhite border-me-light"
                                  flat
                                  hide-details
                                  single-line
                                  solo
                                ></v-text-field>
                              </v-col>
                            </v-row>

                            <table class="tableUI staffTable">
                              <thead>
                                <tr>
                                  <th>Item Name</th>
                                  <th>Category</th>
                                  <th>Brand</th>
                                  <th>Branch Price</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(menu, index) in filteredSearchResult"
                                  :key="index"
                                >
                                  <td>{{ menu.name }}</td>
                                  <td>{{ menu.categories[0].name }}</td>
                                  <td>{{ menu.menubrand.brandName }}</td>
                                  <td class="fourth-th">
                                    <!-- For menu with more than 1 variation -->
                                    <div v-if="menu.menuvariations.length > 1">
                                      Variant
                                    </div>

                                    <!-- For menu with more only 1 variation -->
                                    <div v-if="menu.menuvariations.length == 1">
                                      <div v-if="menu.menuvariations[0]">
                                        {{ menu.menuvariations[0].price }}
                                      </div>
                                    </div>
                                    <!-- <v-text-field
                                      disabled
                                      placeholder="150.00"
                                      outlined
                                      class="table-location-v-text-field"
                                      dense
                                      hide-details
                                    ></v-text-field> -->
                                  </td>
                                  <td class="py-3">
                                    <v-switch
                                      v-model="menu.isAvailable"
                                      disabled
                                      @change="
                                        switchModifierAvailability(
                                          menu.id,
                                          menu.isAvailable
                                        )
                                      "
                                      style="
                                        max-width: 50px;
                                        margin: 0 auto !important;
                                      "
                                      color="primary"
                                      hide-details
                                      inset
                                      class="ma-0"
                                    ></v-switch>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <v-btn class="success btn-save">Save</v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-tab-item>

                    <v-tab-item id="tab-3">
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <v-row justify="space-between" class="rowNoHeight">
                            <v-col cols="2">
                              <h2>Tax Rates</h2>
                            </v-col>
                            <v-col cols="2">
                              <v-btn
                                :ripple="false"
                                depressed
                                color="#60a45f"
                                class="gen-button white--text"
                                width="100%"
                                @click="openAddTax"
                              >
                                <v-icon>add</v-icon>
                                <span>Add Tax</span>
                              </v-btn>
                            </v-col>
                          </v-row>

                          <div
                            class="table-menu mt-0"
                            v-if="locTaxes.length > 0"
                          >
                            <table class="tableUI staffTable">
                              <colgroup>
                                <col span="1" style="width: 20%" />
                                <col span="1" style="width: 20%" />
                                <col span="1" style="width: 20%" />
                                <col span="1" style="width: 10%" />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Rate</th>
                                  <th style="text-align: center">
                                    Set As Default
                                  </th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(tax, index) in locTaxes"
                                  :key="index"
                                >
                                  <td>{{ tax.name }}</td>
                                  <td>{{ tax.rate }}</td>
                                  <td>
                                    <v-checkbox
                                      v-model="tax.setAsDefault"
                                      disabled
                                      dense
                                      class="d-flex justify-center"
                                    ></v-checkbox>
                                  </td>
                                  <td
                                    class="d-flex justify-space-around align-center"
                                  >
                                    <v-btn
                                      :ripple="false"
                                      x-small
                                      text
                                      class="white py-4 btn-outlined"
                                      @click="openAddTax('edit', tax)"
                                    >
                                      <v-icon>edit</v-icon>
                                    </v-btn>
                                    <span class="mx-2"></span>
                                    <v-btn
                                      :ripple="false"
                                      text
                                      x-small
                                      class="white py-4 btn-outlined"
                                      @click="
                                        deleteTax(tax.id);
                                        loaderNum = index;
                                      "
                                      ><v-icon>delete_forever</v-icon></v-btn
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div v-else class="mt-10">
                            No Tax for this location yet. Click on
                            <b>Add Tax</b> to get started
                          </div>
                        </v-col>
                      </v-row>
                    </v-tab-item>

                    <v-tab-item id="tab-4">
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <v-row justify="space-between" class="rowNoHeight">
                            <v-col cols="2">
                              <h2>Surcharges</h2>
                            </v-col>
                            <v-col cols="2">
                              <v-btn
                                :ripple="false"
                                depressed
                                color="#60a45f"
                                class="gen-button white--text"
                                width="100%"
                                @click="openNewSurcharge"
                              >
                                <v-icon>add</v-icon>
                                <span>Add Surcharge</span>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <div
                            class="table-menu mt-0"
                            v-if="locSurcharges.length > 0"
                          >
                            <table
                              class="tableUI staffTable"
                              v-if="locSurcharges.length > 0"
                            >
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Rate</th>
                                  <th>Call Center</th>
                                  <th>Cashier App</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="surcharge in locSurcharges"
                                  :key="surcharge.id"
                                >
                                  <td>{{ surcharge.name }}</td>
                                  <td>
                                    {{
                                      surcharge.surchargeType == 1
                                        ? "Percentage"
                                        : "Fixed"
                                    }}
                                  </td>
                                  <td>
                                    {{ surcharge.rate }}
                                    <span v-if="surcharge.surchargeType == 1">
                                      %
                                    </span>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="surcharge.callCenter"
                                      disabled
                                      checked
                                      class="text-center noSpaceCheckbox"
                                      hide-details
                                      color="primary"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="surcharge.cashierApp"
                                      disabled
                                      class="text-center noSpaceCheckbox"
                                      hide-details
                                      color="primary"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div v-else class="mt-10">
                            No Surcharge available for this location yet. Click
                            on <b>Add Surcharge</b> to get started
                          </div>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Surcharge -->
                <div v-if="addNewSurchargeActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add A New Surcharge</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row justify="center" class="d-flex align-center my-5">
                      <v-col cols="3" class="py-0">
                        <div class="text-right">Name:</div>
                      </v-col>
                      <v-col cols="9" class="py-0">
                        <v-text-field
                          v-model="surchargeName"
                          outlined
                          hide-details
                          placeholder="First Timer"
                          :rules="[rules.required]"
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="center" class="d-flex align-center my-5">
                      <v-col cols="3" class="py-0">
                        <div class="text-right">Surcharge Type:</div>
                      </v-col>
                      <v-col cols="9" class="py-0">
                        <v-select
                          v-model="surchargeType"
                          outlined
                          :rules="[rules.required]"
                          :items="[
                            { value: '1', text: 'Percentage %' },
                            { value: '2', text: 'Fixed' },
                          ]"
                          dense
                          placeholder="Percentage %"
                          offset-y
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>

                    <v-row justify="center" class="d-flex align-center my-5">
                      <v-col cols="3" class="py-0">
                        <div class="text-right">Rate:</div>
                      </v-col>
                      <v-col cols="9" class="py-0">
                        <v-text-field
                          v-model="surchargeRate"
                          outlined
                          hide-details
                          :rules="[rules.required]"
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row justify="center" class="d-flex align-center my-5">
                      <v-col cols="3" class="py-0">
                        <div class="text-right">Enable for:</div>
                      </v-col>
                      <v-col cols="9" class="py-0">
                        <div class="d-flex">
                          <v-chip
                            @click="forCallCenter = !forCallCenter"
                            :color="
                              forCallCenter ? 'primary' : 'grey lighten-3'
                            "
                          >
                            Call Center
                          </v-chip>
                          <span class="mx-3"></span>
                          <v-chip
                            @click="forCashierApp = !forCashierApp"
                            :color="
                              forCashierApp ? 'primary' : 'grey lighten-3'
                            "
                          >
                            Cashier App
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :loading="saveLoader"
                      :ripple="false"
                      color="primary"
                      class="white--text"
                      @click="addNewSurcharge()"
                    >
                      Save
                    </v-btn>
                  </div>
                </div>

                <!-- Add New Tax -->
                <div v-if="addNewTaxActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add A New Tax</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row justify="center" class="d-flex align-center my-5">
                      <v-col cols="3" class="py-0">
                        <div class="text-right">Name:</div>
                      </v-col>
                      <v-col cols="9" class="py-0">
                        <v-text-field
                          v-model="taxName"
                          outlined
                          hide-details
                          placeholder="Value Added Tax"
                          :rules="[rules.required]"
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row justify="center" class="d-flex align-center my-5">
                      <v-col cols="3" class="py-0">
                        <div class="text-right">Rate %:</div>
                      </v-col>
                      <v-col cols="9" class="py-0">
                        <v-text-field
                          v-model="taxRate"
                          outlined
                          hide-details
                          :rules="[rules.required]"
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row justify="center" class="my-5">
                      <v-col cols="3" class="py-0">
                        <div class="text-right">Default tax?:</div>
                      </v-col>
                      <v-col cols="9" class="py-0 d-flex align-center">
                        <v-checkbox
                          v-model="setAsDefault"
                          class="noSpaceCheckbox"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :loading="saveLoader"
                      :ripple="false"
                      color="primary"
                      class="white--text"
                      @click="addNewTax"
                    >
                      Save
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <!-- VIEW END -->
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      currentTab: "tab-1",
      loader: false,
      title: "",
      name: "",
      dataReady: false,
      locationId: this.$route.params.locationId,
      saveLoader: false,
      deleteLoader: false,
      editMode: false,
      menus: [],
      locationName: "",
      addressLineOne: "",
      addressLineTwo: "",
      city: "",
      timeZone: "",
      currency: "",
      telephoneNumber: "",
      locSurcharges: [],
      surchargeName: "",
      surchargeType: "",
      surchargeRate: "",
      forCallCenter: false,
      forCashierApp: false,
      image: [], // must be an array
      isSelected: false,
      url: "",
      origUrl: "",
      getTimeZone: "",
      switch1: true,
      openDialog: false,
      addNewSurchargeActive: false,
      addNewTaxActive: false,
      locTaxes: [],
      taxName: "",
      taxRate: "",
      currentTax: {},
      setAsDefault: false,
      rules: {
        required: (value) => !!value || "Required",
        numberMax15: (value) =>
          !value ||
          (/^[0-9]*$/.test(value) && value.length < 16) ||
          "Must by phone digit (Max. 15)",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
      searchQuery: "",
    };
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
  methods: {
    getOwnTaxes() {
      axios
        .get("/api/v1/tax/?locationId=" + this.locationId, {
          headers: { Authorization: this.$store.state.token },
        })
        .then((response) => {
          this.locTaxes = response.data.data;
        })
        .catch(() => {});
    },
    switchMenuAvailability(id, isAvailable) {
      //   Start Loader
      this.loader = true;

      let url = "";
      isAvailable == false
        ? (url = "/api/v1/menu/" + id + "?status=unavailable")
        : (url = "/api/v1/menu/" + id + "?status=available");
      axios
        .patch(
          url,
          {},
          {
            headers: { Authorization: this.$store.state.token },
          }
        )
        .then(() => {
          this.$store.dispatch("getAllModifiers");

          this.snackBar.active = true;
          this.snackBar.text = "Status updated successfully";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.loader = false;
        })
        .catch(() => {
          this.snackBar.active = true;
          this.snackBar.text = "Status update failed";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.loader = false;
        });
    },
    openNewSurcharge() {
      this.addNewSurchargeActive = true;
      this.openDialog = true;
    },
    openAddTax(edit, tax) {
      this.addNewTaxActive = true;
      this.openDialog = true;

      if (edit == "edit") {
        this.editMode = true;

        this.taxName = tax.name;
        this.taxRate = tax.discountType;
        this.taxRate = tax.rate;

        this.currentTax = tax;
      }
    },
    getLocationDetails() {
      axios
        .get("/api/v1/location/" + this.locationId, {
          headers: { Authorization: this.$store.state.token },
        })
        .then((response) => {
          this.dataReady = true;

          const data = response.data.data;

          // Data
          this.menus = data.menus;
          this.title = data.locationName;
          this.name = data.locationName;
          this.locationName = data.locationName;
          this.addressLineOne = data.addressLineOne;
          this.addressLineTwo = data.addressLineTwo;
          this.city = data.city;
          this.timeZone = data.timeZone;
          this.currency = data.currency;
          this.telephoneNumber = data.phone;
          this.url = data.locationImage || "";
          this.origUrl = data.locationImage;

          // Make image preview show if image exists
          this.url.length > 5
            ? (this.isSelected = true)
            : (this.isSelected = false);
        })
        .catch(() => {});
    },
    getOwnSurcharges() {
      axios
        .get("/api/v1/surcharge/?locationId=" + this.locationId, {
          headers: { Authorization: this.$store.state.token },
        })
        .then((response) => {
          this.locSurcharges = response.data.data;
        })
        .catch(() => {});
    },
    previewImage() {
      if (this.image) {
        this.isSelected = true;
        this.url = URL.createObjectURL(this.image);
      }
    },
    clearSelected() {
      this.image = [];
      this.url = this.origUrl;
    },
    async updateLocation() {
      if (this.$refs.updateLocationForm.validate()) {
        this.saveLoader = true;

        const location = new FormData();

        location.append("locationName", this.locationName);
        location.append("addressLineOne", this.addressLineOne);
        location.append("addressLineTwo", this.addressLineTwo);
        location.append("city", this.city);
        location.append("timeZone", this.timeZone);
        location.append("currencyId", this.currency);
        location.append("phone", this.telephoneNumber);

        if (this.image.type) {
          location.append("locationImage", this.image);
        }

        axios
          .put("/api/v1/location/" + this.locationId, location, {
            headers: { Authorization: this.$store.state.token },
          })
          .then(() => {
            this.saveLoader = false;

            setTimeout(() => {
              this.$router.push("/locations");
            }, 1000);
          })
          .catch((error) => {
            this.saveLoader = false;

            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error updating Location";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      }
    },
    addNewSurcharge() {
      this.saveLoader = true;

      const data = {
        name: this.surchargeName,
        locationId: this.locationId,
        rate: this.surchargeRate,
        surchargeType: this.surchargeType,
        callCenter: this.forCallCenter,
        cashierApp: this.forCashierApp,
      };
      axios
        .post("/api/v1/surcharge/", data, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.saveLoader = false;

          this.addNewSurchargeActive = false;
          this.openDialog = false;

          // Refresh Surcharge
          this.getOwnSurcharges();
        })
        .catch((error) => {
          this.saveLoader = false;

          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Error addIng Surcharge";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        });
    },
    addNewTax() {
      this.saveLoader = true;

      let route;
      let reqType;

      const data = {
        name: this.taxName,
        locationId: this.locationId,
        rate: this.taxRate,
        setAsDefault: this.setAsDefault,
      };

      if (this.editMode == true) {
        route = "/api/v1/tax/" + this.currentTax.id;
        reqType = "put";
      } else {
        route = "/api/v1/tax/";
        reqType = "post";
      }
      axios({
        method: reqType,
        url: route,
        headers: { Authorization: this.$store.state.token },
        data: data,
      })
        .then(() => {
          this.saveLoader = false;

          this.addNewSurchargeActive = false;
          this.openDialog = false;

          // Refresh Tax
          this.getOwnTaxes();
        })
        .catch((error) => {
          this.saveLoader = false;

          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Error addIng Surcharge";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        });
    },
    deleteTax(id) {
      axios
        .delete("/api/v1/tax/" + id, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          // Refresh Own Taxes
          this.getOwnTaxes();
        })
        .catch(() => {});
    },
    deleteLocation() {
      this.deleteLoader = true;

      axios
        .delete("/api/v1/location/" + this.locationId, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.dataReady = false; //just to show the pre-laoder for a sec
          setTimeout(() => {
            this.$router.push("/locations");
            this.deleteLoader = false;
          }, 500);
        })
        .catch(() => {
          this.deleteLoader = false;
        });
    },
    previewImageSelected() {
      this.url = URL.createObjectURL(this.image);
    },
  },
  watch: {
    openDialog(val) {
      if (val == false) {
        this.$refs.dialogForm.reset();

        this.addNewSurchargeActive = false;
        this.addNewTaxActive = false;

        this.$refs.dialogForm.reset();
        this.editMode = false; // VERY IMPORTANT: Always negate data after each edit request
      }
    },
  },
  created() {
    this.$store.dispatch("getAllCategories");
    this.$store.dispatch("getAllCurrencies");

    this.getLocationDetails();
    this.getOwnSurcharges();
    this.getOwnTaxes();

    this.$store.dispatch("getTimeZones").then((response) => {
      this.getTimeZone = response.data;
    });
    this.$store.dispatch("getIPtimeZones").then((response) => {
      this.timeZone = response.data.timezone;
    });
  },
  computed: {
    filteredSearchResult() {
      let grabArr = this.menus;

      return grabArr.filter((item) => {
        if (
          item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1 // search by name
        ) {
          return item;
        }
      });
    },
    ...mapState([
      "mainNav",
      "categories",
      "enterpriseLocations",
      "allEntCurrencies",
    ]),
  },
};
</script>

<style scoped>
.flex3-div,
.flex2-div {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.created-tags-div {
  margin-top: 4%;
}

.tag-btn {
  margin-right: 1%;
  margin-top: 1%;
}

.tag-name {
  text-transform: capitalize;
}

.tag-icon {
  color: black;
  font-size: 12px;
}

.all-tags {
  border: 1px solid lightgrey;
  flex: auto;
}

.form-group {
  margin-bottom: 14px;
}

.form-group .label-spacing {
  width: 18%;
  text-align: right;
}

.uploadPreview {
  width: 300px;
  height: 300px;
}

.tableUI tbody tr td:last-child {
  padding-top: 18px;
  border: 0;
}

.tableUI tbody tr td:last-child {
  padding-top: 18px;
  border: 0;
}
</style>
